export const DRONE_NAME_FIELD_NAME = 'name';

export const FAA_REGISTRATION_NUMBER_FIELD_NAME = 'faaRegistrationNumber';

export const TEST_ID = 'droneFormFields';
